export const countOtherFilters = (filters: FilterDefinition[]): number => {
  const getAllTargetPayloadFilter = () => {
    const targetPayload = filters
      .filter((temp) => temp.filterType === "target")
      .reduce((acc: string[], temp) => {
        const values: string[] = Object.values(
          temp.payload as TargetFilterPayload
        ).filter((value) => value !== undefined);
        return acc.concat(values);
      }, []);

    return targetPayload;
  };
  const otherFilters = filters.filter((f) => {
    if (["watchList", "target", "producerIds"].includes(f.filterType))
      return false;

    const hasValue = f.filterValue !== "" || Boolean(f.payload);
    return hasValue;
  }).length;

  const totalCount = getAllTargetPayloadFilter().length + otherFilters;
  return totalCount;
};
